import MauEvent from '@adobe-fonts/site/events/MauEvent.js';

import { post } from './secure_fetch.js';

/**
 * Send a MAU event to the server. Fire-and-forget.
 * Callers that need debouncing should wrap with underscore's `debounce`.
 * @param {string} eventCode - One of TYPEKIT_FONT_FILTER, TYPEKIT_FONT_SPECIMEN_EDIT, TYPEKIT_FONT_LIBRARY_UPDATE
 */
export function sendMauEvent(eventCode) {
  post('/analytics/events', {
    body: JSON.stringify({ event_code: eventCode })
  }).catch(function() {}); // fire-and-forget
}

/**
 * Initialize listener for MauEvent custom events from adobe-fonts-site components.
 * Bridges the window event to the MAU HTTP endpoint.
 */
export function initMauEventListener() {
  window.addEventListener(MauEvent.EVENT_NAME, function(event) {
    if (event.detail && event.detail.eventCode) {
      sendMauEvent(event.detail.eventCode);
    }
  });
}
